import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import GalleryCategoryForm from "./GalleryCategoryForm";

export default function AddGalleryCategory() {
  const navigate = useNavigate();
  const [data, setData] = useState({ name: "", status: "0" });
  const [saving, setSaving] = useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!data.name.trim()) return toast.error("Category name is required.");
    setSaving(true);
    try {
      const response = await ApiRequest("POST", ApiEndpoints.galleryCategory.create, data);
      toast.success(response.message); navigate("/gallery-categories");
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to create category.");
    } finally { setSaving(false); }
  };
  return <><AdminHeader pagename={{ name: "Gallery Management", user: "Admin", innerpage: "Gallery Categories / Add" }} />
    <div className="add-content-page"><GalleryCategoryForm formId="categoryAdd" data={data}
      setData={setData} onSubmit={handleSubmit} saving={saving} />
      <button form="categoryAdd" className="default-btn" disabled={saving}>Publish <span></span></button>
    </div></>;
}
